<template>
  <div class="member">
    <BaseTable
        :settings="settings" 
        :fields="fields"
        :items="result"
        :searchTerm="$store.state.searchTerm"
        sortBy="familyname"
        sortOrder="asc"
        rowClass="familyname"
        tableId="1" />
  </div>
</template>

<script>

import EventBus from "../bus";
import BaseTable from "../components/table/_BaseTable";
import functions from '../mixins/functions';

export default {
  name: 'home',
  mixins: [functions],
  data () {
    return {
      result: [],
      settings: { rowMax: 25, searchinput: false },
      fields: [
        { label: "Anrede", show: "salutation", width: "65px"},
        { label: "Vorname", show: "prename"},
        { label: "Nachname", show: "familyname"},
        { label: "Geschlecht", show: "geschlecht", width: "100px", classes: ["center", "icon"], hclasses: ["center"], iconcolname: "geschlecht_icon"},
        { label: "PLZ", show: "plz", width: "80px", classes: ["center"], hclasses: ["center"]},
        { label: "Ort", show: "ort", width: "300px"},
        // { label: "Anzahl SN an RouteSteps", show: "sn_not_finished_quantity", classes: ["center"], hclasses: ["center"]},
        // { label: "F-Planer", show: "qplaner_name", width: "100px", classes: ["ellipsis"]},
        // { label: "P-Planer", show: "planer_name", width: "100px", classes: ["ellipsis"]},
        { label: "Geburtstag", show: "geburtstag", width: "100px", sort: "geburtstag_sort", type: "datetime"},
        { label: "", show: "Mitglied löschen", type: "button", event: "deleteMember", classes: ["center", "button", "img-delete"]},
        { label: "", show: "Mitglied editieren", type: "button", event: "editMember", classes: ["center", "button", "img-edit"]},
      ],
    }
  },
  created: function (){
    this.resetBar();
    this.$store.state.bar.search = true
    this.$store.state.bar.exportToExcel = true
    this.$store.state.bar.add = true
    this.$store.state.bar.birthday = true
    this.$store.state.bar.view = true
    this.$store.state.bar.setting = true

    this.$store.state.isLoading = true
    this.$store.state.heading = "Mitgliederübersicht"
    this.$http.get('/api/get_member.pl').then(function (response) {
        console.log(response.data);
        this.result = response.data.member
        this.$store.state.isLoading = false
        response.data.dberror ? EventBus.$emit("showinfo", "error", response.data.dberror.errorText, 15) : undefined
      });
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    EventBus.$on("deleteMember", (item) => {
      
    });
    EventBus.$on("editMember", (item) => {
      this.$router.push({ name: 'editMember', params: { member_id: item.member_id } })
    });
    EventBus.$on("add", (item) => {
      this.$router.push({ name: 'newMember' })
    });
  },
  components: {
    BaseTable
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/pages/Member.vue